<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <back-link :link="{ name: 'EvalProfiles' }" text="в профили оценки" margin="0 0 20px 0"></back-link>
    <page-heading :heading="profile.name"></page-heading>
    <div>
      <el-tabs value="competencies">
        <el-tab-pane label="Настройки компетенций" name="competencies">
          <el-card>
            <profile-competencies></profile-competencies>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="Настройки участников" name="users">
          <el-card>
            <profile-users></profile-users>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import ProfileCompetencies from "@/modules/evaluation/components/profile/ProfileCompetencies.vue";
import ProfileUsers from "@/modules/evaluation/components/profile/ProfileUsers.vue";
import BackLink from "@/components/BackLink.vue";
export default {
  name: 'eval-profile',
  components: {
    BackLink,
    PageHeading,
    ProfileCompetencies,
    ProfileUsers,
  },
  data() {
    return {
      loading: false,
      profile: [],
    }
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      this.loading = true;
      this.$api.evaluation.profileGet({
        id: this.$route.params.id,
      })
        .then(data => {
          this.profile = data.profile;
        })
        .finally(() => {
        this.loading = false;
        });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>